import React from "react";
import { SEText } from "../../../../../components/SEText";

export const Panel = () => {
  return (
    <>
      <SEText color={"#0061C6"} style={{ marginLeft: 4 }}>
        Painel Gerencial
      </SEText>
    </>
  );
};
